export const hotelRegulationsText = {
    "en-US": `<div>
<b>Dear Guest</b>,<br><br>
We’re thrilled to have you stay with us at <b>Sigma Hostel</b>, where we strive to create a <b>cozy, fun, and safe</b> environment for all our guests.<br>
To help us maintain this atmosphere, we kindly ask that you <b>follow the house rules</b> outlined below.<br>
These guidelines ensure <b>everyone’s comfort, safety, and enjoyment</b>, while also helping us preserve the quality of our property.<br><br>

<b>Important Notice: Adults-Only Property (18+)</b><br><br>
Sigma Hostel is an <b>adults-only property. Children and minors (under 18 years old) are not permitted.</b><br><br>

<b>House Rules:</b><br><br>

<span style="margin-left: 50px">1. <b>Self-Check-In:</b></span><br>
Sigma Hostel operates with a <b>self-check-in system</b>.<br>
To access your room, please complete the <b>Self-Check-In Form</b> sent with your booking confirmation and ensure that your <b>payment is processed</b>.<br>
We are <b>not responsible for any access issues</b> if these steps are not completed.<br><br>

<span style="margin-left: 50px">2. <b>Communication & Services:</b></span><br>
All communication, <b>except in emergencies</b>, should be conducted <b>via email or via our chat system on Whatsapp</b>.<br>
Rooms are <b>cleaned and prepared before your arrival</b>, but the <b>room rate does not include cleaning services during your stay</b>.<br><br>

<span style="margin-left: 50px">3. <b>No Parties or Events:</b></span><br>
Sigma Hostel is a <b>social yet peaceful</b> place.<br>
<b>Parties and events that cause noise or disturbances are strictly prohibited</b> to maintain a pleasant environment for all guests.<br><br>

<span style="margin-left: 50px">4. <b>No Smoking:</b></span><br>
Smoking is <b>prohibited indoors</b>.<br>
Please use <b>designated outdoor smoking areas</b> and dispose of cigarette butts responsibly.<br>
<b>Smoking indoors is subject to a fine of CHF 300.</b><br><br>

<span style="margin-left: 50px">5. <b>No Pets:</b></span><br>
Although we love animals, <b>Sigma Hostel is a pet-free property</b> to ensure a <b>clean and allergen-free</b> environment for all guests.<br><br>

<span style="margin-left: 50px">6. <b>Found Items:</b></span><br>
If you <b>leave anything behind</b>, it will be kept in our <b>lost and found</b>.<br>
Please contact us to arrange a collection, as our office may not always be open.<br><br>

<span style="margin-left: 50px">7. <b>No Unregistered Guests:</b></span><br>
For <b>security and comfort</b>, <b>only guests listed in the booking are allowed on the premises</b>.<br><br>

<span style="margin-left: 50px">8. <b>No Food or Drinks in Bedrooms:</b></span><br>
Please <b>enjoy your meals and drinks in the common areas</b> to prevent spills and stains in the bedrooms.<br><br>

<span style="margin-left: 50px">9. <b>Quiet Hours:</b></span><br>
To ensure a <b>restful environment</b>, quiet hours are:
<ul>
	<li><b>10:00 PM - 7:00 AM</b></li>
	<li><b>12:00 PM - 1:00 PM</b></li>
	<li>Sundays and public holidays are also considered <b>quiet times</b>.</li>
</ul>

<span style="margin-left: 50px">10. <b>Check-In and Check-Out Times:</b></span><br>
Check-in time is at 16.00 am and check-out time is at 11.00 am. Please <b>respect our check-in and check-out times</b> to help us manage cleaning schedules and prepare for incoming guests.<br><br>

<span style="margin-left: 50px">11. <b>Key Care:</b></span><br>
Please take care of your room key. <b>Lost keys will incur a replacement fee of 300 CHF.</b><br><br>

<span style="margin-left: 50px">12. <b>Respect for Furniture and Property:</b></span><br>
<b>Treat the property with care</b> and report any damages.<br>
If damages <b>exceed the security deposit</b>, additional charges will apply.<br><br>

<span style="margin-left: 50px">13. <b>No Rearranging Furniture:</b></span><br>
Please <b>do not move or rearrange furniture</b>, as this can cause damage and create extra work for our team.<br><br>

<span style="margin-left: 50px">14. <b>Dishes:</b></span><br>
We kindly ask that you <b>wash your dishes after use</b> to help us maintain a clean and ready space for the next guest.<br><br>

<span style="margin-left: 50px">15. <b>Trash Disposal:</b></span><br>
Please <b>take out your trash before checking out</b> to keep the hostel tidy.<br><br>

<span style="margin-left: 50px">16. <b>No Illegal Substances:</b></span><br>
The <b>use or possession of illegal substances is strictly forbidden</b> to ensure a safe and legal environment for all guests.<br><br>

<span style="margin-left: 50px">17. <b>No Prostitution:</b></span><br>
<b>Prostitution is strictly prohibited</b> at Sigma Hostel.<br>
<b>Violation of this rule will result in a 1,000 CHF fine and a report to the authorities.</b><br><br>

By following these rules, you’re helping us keep <b>Sigma Hostel</b> a <b>welcoming, enjoyable, and safe</b> place for everyone.<br>
We <b>appreciate your cooperation</b> and hope you have a <b>fantastic stay!</b><br><br><br>

<b>Warm regards,<br>
The Sigma Hostel Team</b>
</div>`
};